import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import {makeStyles} from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import {useTranslation} from 'react-i18next';


const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiDialogContent-root': {
      padding: '20px 24px',

    },
    '& .MuiDialogActions-root': {
      paddingLeft: '24px',
      paddingRight: '24px'
    }
  },

}));

export default function RemoveRowConfirmationDialog({open, onClose, onConfirm, description}) {
  const [t] = useTranslation();
  const classes = useStyles();
  return (
    <Dialog className={classes.root} onClose={onClose} open={open}>
      <DialogTitle disableTypography>
        <Typography variant="h1">{t('modal.removeRow.title')}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>{t('modal.removeRow.body', {item: description})}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="outlined"
          onClick={onClose}
        >
          {t('modal.removeRow.no')}
        </Button>
        <Button
          color="secondary"
          variant="contained"
          onClick={onConfirm}
        >
          {t('modal.removeRow.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
